export type TermsResponse = {
  isUser: boolean;
  terms: Terms[];
};

export type TermsContentsResponse = {
  terms: TermsContents[];
};

export type TermsSubmitResponse = {
  code: string;
  data: unknown;
  message: string;
};

export type TermsContents = {
  title: string;
  termsVersion: string;
  contentUrl: string;
  sortableDate: string;
};

export type Terms = {
  category: TermsCategory;
  isAgreed: boolean;
  isRequired: boolean;
  isUpdated: boolean;
  title: string;
  type: number;
  version: string;
};

export enum TermsCategory {
  INFO_COLLECTION = 5,
  RECEIVE_MARKETING_INFO = 6,
}
